var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 5,
    viewBox: "0 0 413 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 315,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 405,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "#0957A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaves);
export default __webpack_public_path__ + "static/media/sound-waves.1ee1f7b9dffc0301c1dd39aea59cfce9.svg";
export { ForwardRef as ReactComponent };